<template>
    <ModalBase
        :name="modalName"
        title="Editar documento"
        @close="close()"
    >
        <div class="tw:flex tw:flex-col tw:gap-4">
            <BaseInputText
                label="Nombre"
                name="nombre"
                rules="required"
                :value="documentoLocal.nombre"
                @input="documentoLocal.nombre = $event"
            />
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="primary" @click="confirm">Editar</Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, computed, watch } from 'vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        documento: {
            type: Object,
            required: true
        }
    })

    const emit = defineEmits(['close', 'confirm'])
    const documentoLocal = ref(props.documento ? JSON.parse(JSON.stringify(props.documento)) : {})
    const modalName = computed(() => `editar-${props.documento?.id ?? 'nuevo'}`)

    watch(() => props.documento, newDoc => {
        documentoLocal.value = newDoc ? JSON.parse(JSON.stringify(newDoc)) : {}
    })

    const close = () => {
        emit('close')
    }

    const confirm = () => {
        emit('confirm', documentoLocal.value)
    }
</script>
